import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const LandingHero = () => {
  return (
    <div className="hero-content">
      <div className="">
        <h1>
          Grow Your Business <br /> with Shophr
        </h1>
        <p className="hero-subtitle">
          Same-Day delivery, reach new customers, and boost your revenue
          effortlessly.
        </p>
      </div>

      <ul>
        <li>
          <FaCheckCircle color="green" />
          Collaborate on delivery schedules with your team
        </li>
        <li>
          <FaCheckCircle color="green" />
          Provide immediate delivery updates and integrate with tracking
          information
        </li>
        <li>
          <FaCheckCircle color="green" />
          Address delivery issues or finalize orders instantly through chat
        </li>
      </ul>
    </div>
  );
};

export default LandingHero;
